<template>
    <div style="width: 100%;overflow: hidden">
        <!--  发布红包问题     -->
        <!--                 <div style="display: flex; justify-content: center; height: auto;overflow: hidden">-->
        <el-card style="width: 100%;" shadow="hover">
            <div style="display: flex;justify-content: center">
                <div style="width: 168px;height: 33px;font-size: 28px;color: #333333;float: left">{{file_name}}</div>
            </div>
            <el-form ref="form"  inline >
                <div style="font-size: 18px;margin-left: 30px;color: #444444;font-weight:bold"><span style="color: #FF2A72 ">*</span>{{description_title}}</div>
                <el-form-item prop="title" style="margin-left: 30px;margin-top: 5px;float: left">
                    <el-input style="width: 630px;" type="text" :placeholder=description_title_prompt v-model="title"  :show-word-limit="true"  maxlength="150" minlength="10"  />
                </el-form-item>
                <!--    问题分类   -->
                <div style="width: 162px;float: left;margin-top: 4px;">
                    <el-form-item prop="type_id" style="width: 300px">
                        <el-cascader v-model="type_id" :options="type_list"  placeholder="选择问题分类"></el-cascader>
                    </el-form-item>
                </div>
                <div style="font-size: 17px;padding-left: 30px;clear: both;font-weight:bold"><span style="color: #FF2A72 ">*</span>{{description_Supplement}}</div>
                <el-form-item prop="content" style="margin-left: 30px;padding-top: 5px;">
                    <el-input style="width: 860px" type="textarea" resize="none" :rows="5" :placeholder=description_Supplement_prompt v-model="content" :autosize="{ minRows: 5, maxRows: 10 }" :show-word-limit="true" maxlength="1000" minlength="10" @input="content_input" />
                </el-form-item>
                <div>
                    <!--    上传多媒体     -->
                    <div style="margin-left: 27px;">
                        <div class="input_box_btn op sc hand" @click="set_upload_img_open" style="position: relative; margin-right: 8px">
                            <div class="input_box_btn_icon" >
                                <svg t="1700457632553" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11668" width="25" height="25"><path d="M632 992H172.8c-70.4 0-128-57.6-128-128V352c0-176 144-320 320-320h267.2c70.4 0 128 57.6 128 128v704c0 70.4-57.6 128-128 128z" fill="#E1E1DF" p-id="11669"></path><path d="M852.8 992H326.4c-70.4 0-128-57.6-128-128V336c0-70.4 57.6-128 128-128h526.4c70.4 0 128 57.6 128 128v528c0 70.4-57.6 128-128 128z" fill="#4E8DF6" p-id="11670"></path><path d="M320 417.6a110.4 110.4 0 1 0 220.8 0 110.4 110.4 0 1 0-220.8 0Z" fill="#FFFFFF" p-id="11671"></path><path d="M875.2 606.4c-48-48-126.4-48-174.4 0L321.6 985.6l-6.4 6.4h536c70.4 0 128-57.6 128-128v-152l-104-105.6z" fill="#2166CC" p-id="11672"></path><path d="M731.2 992l-272-273.6c-48-48-126.4-48-174.4 0l-84.8 86.4V864c0 70.4 57.6 128 128 128h403.2z" fill="#629FF9" p-id="11673"></path></svg>
                            </div>
                            <div class="input_box_btn_name" >上传图片</div>
                            <el-badge :value="imgs.length" v-if="imgs.length > 0" style="position:absolute; z-index:10; left:60px;top: 5px" ></el-badge >
                        </div>
                        <!--  上传视频   -->
                        <div class="input_box_btn op sc hand" @click="set_visibleVideos"  style="position: relative; margin-right: 8px">
                            <div class="input_box_btn_icon" style="margin-left: 10px;margin-top: 2px"><svg t="1700457844773" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14809" width="25" height="25"><path d="M661.942857 73.142857H146.285714c-20.114286 0-36.571429 16.457143-36.571428 36.571429v804.571428c0 20.114286 16.457143 36.571429 36.571428 36.571429h731.428572c20.114286 0 36.571429-16.457143 36.571428-36.571429V325.485714L661.942857 73.142857z" fill="#8095FF" p-id="14810"></path><path d="M661.942857 288.914286c0 20.114286 16.457143 36.571429 36.571429 36.571428H914.285714L661.942857 73.142857v215.771429z" fill="#B6C6FF" p-id="14811"></path><path d="M632.685714 437.028571H301.714286c-20.114286 0-36.571429 18.285714-36.571429 42.057143v279.771429c0 23.771429 16.457143 42.057143 36.571429 42.057143h332.8c20.114286 0 36.571429-18.285714 36.571428-42.057143V479.085714c-1.828571-21.942857-18.285714-42.057143-38.4-42.057143z" fill="#FFFFFF" p-id="14812"></path><path d="M782.628571 513.828571c-9.142857-7.314286-20.114286-10.971429-31.085714-9.142857l-89.6 20.114286c-16.457143 3.657143-29.257143 21.942857-29.257143 42.057143v106.057143c0 20.114286 12.8 38.4 29.257143 42.057143l89.6 20.114285h7.314286c9.142857 0 16.457143-3.657143 23.771428-9.142857 9.142857-7.314286 12.8-20.114286 12.8-32.914286v-146.285714c0-12.8-3.657143-23.771429-12.8-32.914286z" fill="#FFFFFF" opacity=".8" p-id="14813"></path><path d="M488.228571 524.8h104.228572V566.857143h-104.228572z" fill="#8095FF" p-id="14814"></path></svg></div>
                            <div class="input_box_btn_name" >上传视频</div>
                            <el-badge :value="videos.length" v-if="videos.length > 0" style="position:absolute; z-index:100; left:70px;top: 3px" ></el-badge >
                        </div>
                        <!--    上传附件  -->
                        <div class="input_box_btn op sc hand" @click="set_visibleFiles" style="position: relative; margin-right: 8px">
                            <div class="input_box_btn_icon" style="margin-left: 10px;margin-top: 2px;"><svg t="1700458448013" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21815" width="25" height="25"><path d="M881.371 362.057v570.514c0 25.6-18.285 43.886-43.885 43.886H186.514c-25.6 0-43.885-18.286-43.885-43.886V91.43c0-25.6 21.942-43.886 43.885-43.886h431.543l263.314 314.514z m-40.228 3.657L618.057 98.743l3.657 230.4c0 25.6 14.629 40.228 29.257 40.228l190.172-3.657z m-256-285.257H186.514c-7.314 0-10.971 3.657-10.971 10.972v844.8c0 7.314 3.657 10.971 10.971 10.971h650.972c7.314 0 10.971-3.657 10.971-10.971V402.286H650.971c-36.571 0-62.171-32.915-62.171-73.143l-3.657-248.686z" fill="#BEC3CC" p-id="21816"></path><path d="M881.371 501.029H142.63c-18.286 0-29.258 7.314-29.258 25.6v314.514c0 14.628 10.972 25.6 29.258 25.6h742.4c18.285 0 29.257-7.314 29.257-25.6V522.97c-3.657-14.628-10.972-21.942-32.915-21.942zM332.8 760.686h-14.629v-7.315c-3.657-7.314-3.657-14.628-3.657-18.285h14.629c10.971 0 14.628-7.315 14.628-18.286 0-14.629-7.314-32.914-18.285-51.2l18.285-69.486h-29.257v204.8h-25.6v-230.4h76.8v25.6l-18.285 65.829c14.628 18.286 18.285 36.571 18.285 58.514 0 25.6-10.971 36.572-32.914 40.229zM409.6 614.4v186.514H384V658.286c0 3.657-3.657 7.314-7.314 10.971s-7.315 10.972-7.315 10.972c0-3.658-3.657-10.972-3.657-18.286 0-3.657-3.657-10.972-3.657-10.972 18.286-29.257 32.914-58.514 40.229-91.428l25.6 3.657c-3.657 10.971-7.315 25.6-18.286 43.886v7.314zM522.971 640H501.03v120.686c0 25.6-10.972 36.571-32.915 36.571h-29.257c0-10.971-3.657-18.286-3.657-25.6h25.6c14.629 0 18.286-3.657 18.286-18.286V636.343h-51.2v-25.6h51.2v-51.2h25.6v51.2h21.943V640z m-106.057 25.6l21.943-7.314c7.314 18.285 18.286 36.571 25.6 51.2l-21.943 10.971c-7.314-18.286-18.285-36.571-25.6-54.857zM588.8 800.914h-25.6v-128c-7.314 10.972-14.629 25.6-25.6 36.572-3.657-14.629-3.657-25.6-7.314-36.572 18.285-29.257 36.571-65.828 47.543-109.714l25.6 7.314c-3.658 18.286-10.972 36.572-18.286 51.2v179.2z m190.171-80.457H716.8v76.8h-25.6v-76.8h-84.114v-25.6H691.2V640h-40.229c-3.657 14.629-10.971 29.257-14.628 40.229-3.657-3.658-10.972-3.658-18.286-7.315-3.657 0-3.657 0-3.657-3.657 10.971-25.6 21.943-54.857 29.257-95.086l25.6 3.658c-3.657 10.971-3.657 21.942-7.314 32.914h32.914v-54.857h25.6v54.857h54.857v25.6h-54.857v58.514h62.172v25.6z" fill="#0090FF" p-id="21817"></path></svg></div>
                            <div class="input_box_btn_name" >上传文件</div>
                            <el-badge :value="files.length" v-if="files.length > 0" style="position:absolute; z-index:10;left: 70px;top: 5px" ></el-badge >
                        </div>
                        <div style="float: right;margin-right: 20px;font-weight:bold">
                            <el-form-item label="问题悬赏：">
                                <el-switch v-model="need_money" @change="handleSwitchChange" style="padding-top: 10px;"></el-switch>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div v-if="need_money">
                        <div v-if="type == 1 || type == 4" style="width: 100%;clear: both;margin: 0 auto;display: flex;justify-content: space-around;float: left;margin-left: -30px;">
                            <div class="offerareward">悬赏类别</div>
                            <div class="peoold">悬赏人数</div>
                            <div class="offerareward">单人金额</div>
                            <div class="offerareward" style="flex-basis: 18%;">总金额(<span style="color: #FF5E5E;font-weight:bold">{{utils.keepTwoDecimalFull(personamount)}}</span>)
                                <!--    添加按钮     -->
                                <label v-if="hide" style="float: right;">
                                    <el-button style="color: #e6a23c;background-color: #FFFFFF;border: none;padding: 7px 1px;font-size: 14.5px;font-weight: bold" type="primary" size="mini" class="el-icon-s-promotion op sc hand" @click="addto">添加</el-button>
                                </label>
                            </div>
                        </div>
                        <div v-if="type == 2 || type == 3" style="width: 100%;clear: both;margin: 0 auto;display: flex;float: left;padding-left: 27px;">
                            <div class="peoold" style="margin-left: 5px;">悬赏人数</div>
                            <div class="offerareward" style="margin-left: 116px;">单人金额</div>
                          <div class="offerareward" style="margin-left: 110px;">总金额</div>
                        </div>

                        <div v-if=" type == 2 || type == 3" style="width: 100%;display: flex;padding-top: 10px">
                            <div style="width: 150px;margin-left: 30px;">
                                <el-select v-model="value" @change="change_people2" placeholder="请选择">
                                    <el-option v-for="it in optionsobj" :key="it.value" :label="it.label" :value="it.value" ></el-option>
                                </el-select>
                            </div>
                            <div style="width: 150px;margin-left: 30px;">
                                <el-input @input="inputMoney2($event)" v-model="codeamount" placeholder="请输入金额"   ></el-input>
                            </div>
                            <div style="height: 40px;width: 100px;border: 1px solid #DCDFE6;float: left;border-radius: 4px;margin-left: 50px;">
                              <img src="@/assets/imgs/index/release.png" style="width: 20px;height: 20px;padding: 9px 0 0 5px;float: left">
                              <div style="width: auto;float: left;margin-left: 10px;padding-top: 10px;">{{rewardMoney}}<span style="margin-left: 10px;">元</span></div>
                            </div>
                        </div>
                    <div v-for="(item,i) in distribution" :key="i">
                        <div style="display: flex;width: 92%;overflow: hidden;justify-content: space-around;margin-left: -35px;">
                            <!--   几等奖  -->
                            <div style="width:100px;height:30px;font-size: 16px;padding-top: 15px;color: #444444;flex-basis: 10%;margin-left: 20px;font-weight:bold">{{i+1}}等奖</div>
                            <!--  人数  -->
                            <div style="width: 100px;margin-top: 10px;margin-left: 10px;">
                                <el-select v-model="item.people" placeholder="请选择" @change="change_people" @visible-change="change_people_disabled(item)">
                                    <el-option v-for="it in people" :key="it.value" :label="it.label" :value="it.value" :disabled="it.disabled">
                                    </el-option>
                                </el-select>
                            </div>
                            <!--   单人金额    -->
                            <div style="width: 120px;margin-top: 10px;">
<!--                                <el-input placeholder="单人金额" v-model="item.inputMoney" @blur="lose(item)" @input="inputMoney(i,$event)"  oninput="if(value.length>3)value=value.slice(0,3)"  @keyup.native="UpNumber" @keydown.native="UpNumber" > </el-input>-->
                                <el-input placeholder="单人金额" v-model="item.inputMoney" @blur="lose(item)" @input="inputMoney(i,$event)"  oninput="if(value.length>3)value=value.slice(0,3)" > </el-input>
                            </div>
                            <!--  总金额 -->
                            <div style="padding-top: 10px;">
                                <div style="height: 40px;width: 100px;border: 1px solid #DCDFE6;float: left;border-radius: 4px;">
                                    <img src="@/assets/imgs/index/release.png" style="width: 20px;height: 20px;padding: 9px 0 0 5px;float: left">
                                    <div style="width: auto;float: left;margin-left: 10px;padding-top: 10px;">{{utils.keepTwoDecimalFull(item.money)}}<span style="margin-left: 10px;">元</span></div>
                                </div>
                                <div v-if="i == 0" style="padding: 10px 21px 0 5px;float: left" ></div>
                                <div v-if="i >= 1" style="padding: 10px 0 0 5px;float: left" @click="deleteModule(i)"><i style="font-size: 20px;color: #707070" class="el-icon-delete"></i></div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-left: 33px;padding-top: 30px;float: left;">
                        <el-form-item label="悬赏天数" style="font-size: 16px;font-weight:bold">
                            <div style="display: inline">
                                <el-slider v-model="day" :min="1" :max="10" :step="1" show-input style="width: 400px; margin-left: 4.1%"></el-slider>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <el-form-item style="width: 100%; text-align: right;">
                    <!--  发布红包问答 和 比选竞标  -->
                    <div style="padding-right: 20px;margin-top: 10px;">
                        <el-button v-if="(type == 1 || type == 4) && submitType == 1" type="primary" size="small" class="op sc hand"  @click="release(1)" style="margin-right: 10px;color: #FFF;width: 100px;background-color: #409EFF;border: 1px solid #409EFF;font-size: 15px;">立即发布</el-button>
                        <el-button v-if="(type == 1 || type == 4) && submitType == 2" type="primary" size="small" class="op sc hand" @click="release(2)" style="margin-right: 10px;width: 100px;color: #FFF;background-color: #409EFF;border: 1px solid #409EFF;font-size: 15px">去支付</el-button>
                        <!--  发布悬赏资料 和 悬赏讨论  -->
                        <el-button v-if="(type == 2 || type == 3) && submitType == 1" type="primary" size="small" class="op sc hand" @click="releasecode(1)" style="margin-right: 10px;width: 100px;color: #FFF;background-color: #409EFF;border: 1px solid #409EFF;font-size: 15px;">立即发布</el-button>
                        <el-button v-if="(type == 2 || type == 3) && submitType == 2" type="primary" size="small" class="op sc hand" @click="releasecode(2)" style="margin-right: 10px;width: 100px;color: #FFF;background-color: #409EFF;border: 1px solid #409EFF;font-size: 15px">去支付</el-button>
                    </div>
                </el-form-item>
            </el-form>

        </el-card>
        <!--    传图片  -->
        <el-dialog :close-on-click-modal="false" :show-close=false  :append-to-body="true" :visible.sync="visibleImages" width="400px">
            <el-tabs v-model="src_tabs_name" type="border-card">
                <el-upload accept="image/*"  style="width:330px;margin-left: 5px;" class="upload-demo" action="" drag multiple :http-request="upload_img" :limit=80 :show-file-list="false" :on-exceed="fileListNum">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                </el-upload>
            </el-tabs>
            <div style="overflow: hidden; height:20px;line-height:20px; padding: 0 16px; margin-bottom: 10px">
                <div style="float:left;">
                    图片:（{{imgs.length}}）<!-- /9 -->
                </div>
            </div>
            <div style="overflow:hidden; display: flex; flex-wrap: wrap; padding: 0 16px" class="upload">
                <div style="width: 160px; height: 120px; margin-right: 10px; margin-bottom: 10px; border-radius: 5px;background-size:100% 100%;object-fit: cover;" class="img" v-for="(item,index) in imgs" :key="index" :style="{backgroundImage:'url('+item.url}">
                    <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:50%;float:right; cursor:pointer;user-select: none;" @click="removeImg(index)">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: flex-end;">
                <el-button style="width: 80px;border-radius: 5px; margin: 10px 20px" @click="cancelImg">取消</el-button>
                <el-button style="width: 80px;border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 0" @click="visibleImages = false">确定</el-button>
            </div>
        </el-dialog>
        <!-- 传视频 -->
        <el-dialog :close-on-click-modal="false" :show-close=false :append-to-body="true" :visible.sync="visibleVideos" width="400px">
            <el-tabs v-model="active_name" type="border-card">
                <el-upload accept="video/*"  style="width:330px;margin-left: 5px;"  class="upload-demo" action="" drag  :http-request="upload_video" :show-file-list="false">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将视频拖到此处，或<em>点击上传</em></div>
                </el-upload>
            </el-tabs>

            <div style="overflow: hidden; height:20px;line-height:20px; padding: 0 16px; margin-bottom: 10px">
                <div style="float:left;color:#acacac;">
                    视频:（{{videos.length}}）
                </div>
            </div>
            <div style="overflow:hidden;">
                <div v-for="(item,index) in videos" :key="index" :style="{backgroundImage:'url('+item.url+'?x-oss-process=video/snapshot,t_0,f_jpg'}" style="width:80px;height:80px;border-radius:3px; float:left; margin:5px; background-size:100% 100%;position:relative;">
                    <div style="width:100%;height:100%;background-color: rgba(0,0,0,.3);">
                        <img :src="ossUrl + 'img/video_play.png'" style="width:50%;height:50%;margin:25%;" />
                    </div>
                    <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:10px; cursor:pointer;user-select: none;position:absolute;right:0;top:0;" @click="removeVideo(index)">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: flex-end;">
                <el-button style="width: 80px;border-radius: 5px; margin: 10px 20px" @click="cancelVideo">取消</el-button>
                <el-button style="width: 80px;border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 0" @click="visibleVideos = false">确定</el-button>
            </div>
        </el-dialog>
        <!--      传文件   -->
        <el-dialog :close-on-click-modal="false" :show-close=false :append-to-body="true" :visible.sync="visibleFiles" width="400px">
            <el-tabs v-model="file_tag_name" type="border-card">
                <div class="file_style">
                    <div class="dragger-file">
                        <el-upload  accept=".pdf, .doc, .docx, .xls, .xlsx" style="width: 330px;margin-left: 5px" class="upload-demo"  action="" drag multiple :http-request="upload_file" :show-file-list="false" >
                            <i class="el-icon-upload" ></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="format">仅限pdf、doc、docx、xls、xlsx等文件格式</div>
                        </el-upload>
                    </div>
                </div>
            </el-tabs>
            <div style="overflow: hidden; height:20px;line-height:20px; padding: 0 16px; margin-bottom: 10px">
                <div style="float:left;color:#acacac;">
                    附件:（{{files.length}}）<!-- /9 -->
                </div>
            </div>
            <div style="overflow:hidden;">
                <div class="video" v-for="(item,index) in files" :key="index" style="width:80px;height:100px;border-radius:3px; float:left; margin:5px; background-size:100%;position:relative;" :title="item.file_name">
                    <div class="background" style="width:100%;height:calc(100% - 20px);background-color: rgba(0,0,0,.3);">
                        <!-- <div style="width:100%">{{item.file_name}}</div> -->
                        <img :src="ossUrl+'img/file.png'" style="width:100%;height:100%;" />
                    </div>
                    <div style="height:20px;width:70px;margin: 0 5px;line-height: 20px;text-align: center;word-break:keep-all;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{item.name}}</div>
                    <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:10px; cursor:pointer;user-select: none;position:absolute;right:0;top:0;" @click="removeFile(index)">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: flex-end;">
                <el-button style="width: 80px;border-radius: 5px; margin: 10px 20px" @click="cancelFiles">取消</el-button>
                <el-button style="width: 80px;border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 0" @click="visibleFiles = false">确定</el-button>
            </div>
        </el-dialog>
        <!--            </div>-->

    </div>
</template>

<script>

    import AaDaPayCode from "./Pay/AaDaPayCode";
    export default {
        components: {
            AaDaPayCode
        },
        name: "question",
        data() {
            return {
                ossUrl:"https://oss.baigongbao.com/",
                loading:false,
                type_list: [],
                at_open: false,
                type:0,
                imgs:[],
                visibleImages: false,
                visibleVideos: false,
                visibleFiles:false,
                src_tabs_name: "pc",
                active_name: "pc",
                file_tag_name: 'pc',
                upload_qrcode:"https://baigongbao.oss-cn-beijing.aliyuncs.com/img/xcx_qrcode.jpg-80*80",
                videos:[],
                files:[],
                options:'',
                deadline: "",
                title: "",
                content: "",
                type_id: "",
                need_money: "0",
                price: 5,
                answer_number: 1,
                day: 1,
                distribution:[],
                hide:true,
                file_name:"",
                description_title:"",
                description_title_prompt:"",
                description_Supplement:"",
                description_Supplement_prompt:"",
                // 红包问答悬赏人数
                people:[{
                    value: 1,
                    label: '1',
                    disabled:false,
                }, {
                    value: 2,
                    label: '2',
                    disabled:false,
                }, {
                    value: 3,
                    label: '3',
                    disabled:false,
                }, {
                    value: 4,
                    label: '4',
                    disabled:false,
                }, {
                    value: 5,
                    label: '5',
                    disabled:false,
                }, {
                    value: 6,
                    label: '6',
                    disabled:false,
                }],
                code:'',
                orderNo:'',
                chanfeIndex:0,
                sumPeople:0,
                personamount:0,
                countdownNum:60,
                shopType:"",
                codeamount:1,
                //资料悬赏人数
                optionsobj:[{
                    value: 1,
                    label: '1',
                }, {
                    value: 2,
                    label: '2',
                }, {
                    value: 3,
                    label: '3',
                }, {
                    value: 4,
                    label: '4',
                }, {
                    value: 5,
                    label: '5',
                }, {
                    value: 6,
                    label: '6',
                }],
                value:"",
                payPwd:"",
                submitType:1,
                rewardMoney:0,
                roomId:0,
                isReward:0,
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        props:{
            awType:{
                type:String,
                default() {
                    return "";
                }
            },
            form:{
                type:Number,
                default() {
                    return 0;
                }
            }
        },
        watch :{
            need_money :{
                handler (newVal,oldval){
                    if (newVal == true){
                        this.submitType = 2;
                    }else {
                        this.submitType = 1;
                    }
                }
            }
        },

        created() {
            this.get_type_list();
        },
        mounted: function () {
            var that = this;
            if(typeof this.$route.params.id != "undefined"){
                that.roomId = this.$route.params.id;
            }
            that.type = parseInt(that.awType);
            if(that.type == 1){
                that.file_name="红包问题";
                that.description_title = "问题描述";
                that.description_title_prompt = "一句话描述您的问题";
                that.description_Supplement = "问题补充说明";
                that.description_Supplement_prompt = "在这里继续补充您的问题细节";
            }else if(that.type == 2){
                that.file_name="悬赏资料";
                that.description_title = "资料名称";
                that.description_title_prompt = "简要描述您需要的资料名称";
                that.description_Supplement = "资料补充说明";
                that.description_Supplement_prompt = "在这里继续补充您所需的资料详情";
            }else if(that.type == 3){
                that.file_name="悬赏讨论";
                that.description_title = "讨论话题";
                that.description_title_prompt = "一句话描述您想要讨论的话题";
                that.description_Supplement = "话题补充说明";
                that.description_Supplement_prompt = "在这里继续补充您想要讨论的话题细节";
            }else if(that.type == 4){
                that.file_name="比选竞标";
                that.description_title = "竞标名称";
                that.description_title_prompt = "简要描述您需要必选竞标的竞标名称";
                that.description_Supplement = "必选竞标补充说明";
                that.description_Supplement_prompt = "在这里继续补充您需要必选竞标的详情内容";
            }
        },
        methods: {
            addto:function() {
                var that = this;
                if(that.distribution.length >= 2){
                    that.hide=false;
                }
                var obj = {
                    people:that.people,
                    money:1,
                    inputMoney:1,
                    chanfeIndex:0
                }
                that.distribution.push(obj);
            },
            //监听是否开启悬赏
            handleSwitchChange(value) {
                var that = this;
                if (value == true){
                    if(that.type == 1 || that.type == 4) {
                        if(that.distribution.length >= 2){
                            that.hide=false;
                        }
                        var obj = {
                            people:that.people,
                            money:1,
                            inputMoney:1,
                            chanfeIndex:0
                        }
                        if (that.distribution.length == 0){
                            that.distribution.push(obj);
                        }
                    }
                }else{
                    that.distribution = [];
                }
            },

            //计算1、4类型的总金额
            inputMoney(i,event){
                var that = this;
                // var inputMoney = this.distribution[i].inputMoney;
                // inputMoney = parseInt(inputMoney); // 仅保留数字
                // if (inputMoney < 1) {
                //     that.distribution[i] .inputMoney= '1';
                // }
                that.personamount = 0;
                for (let j = 0; j < that.distribution.length; j++) {
                    that.distribution[j].money = that.distribution[j].people * parseFloat(that.distribution[j].inputMoney);
                    if(!isNaN(that.distribution[j].money)){
                        that.personamount += that.distribution[j].money;
                    }else{
                        that.personamount += 0;
                        that.distribution[j].money = 0;
                    }
                }

                if (that.personamount > 0){
                    that.submitType = 2;
                }
            },

            //计算2、3类型的总金额
            inputMoney2(){
                var that = this;
                // 通过正则表达式确保输入为数字，并且不小于1
                // this.codeamount = this.codeamount.replace(/[^0-9]/g, ''); // 仅保留数字
                // if (this.codeamount === '' || parseInt(this.codeamount) < 1) {
                //     this.codeamount = '1';
                // }

                if(that.codeamount > 0){
                    that.rewardMoney = (that.codeamount * 100) * (that.value * 100) / 10000;
                    that.submitType = 2;
                }
            },

            //计算2、3类型的总金额
            change_people2(){
                var that = this;
                that.rewardMoney = (that.codeamount * 100) * (that.value * 100) / 10000;
            },

            //1、/4类型的金额选择
            change_people(){
                var that = this;
                that.sumPeople = 0;
                that.personamount = 0;
                console.log(that.distribution)
                for (let j = 0; j < that.distribution.length; j++) {
                    that.sumPeople += that.distribution[j].people;
                    that.distribution[j].money = that.distribution[j].people * parseFloat(that.distribution[j].inputMoney);
                    that.personamount += that.distribution[j].money;
                }
            },
            //1、/4类型的人数选择
            change_people_disabled(e){
                var that = this;
                let surplus = 6-that.sumPeople;
                if (e.people!==""){
                    surplus = surplus+e.people;
                }
                for (let i = 0; i < that.people.length; i++) {
                    if (that.people[i].value<=surplus){
                        that.people[i].disabled=false;
                    }else {
                        that.people[i].disabled=true;
                    }
                }
            },

            //发布于1、4
            release:function(type) {
                var that = this;
                var params = {};
                if(that.need_money){
                    that.isReward = 1;
                }
                params.isReward = that.isReward;
                if(that.type_id.length == 0){
                    that.utils.err("请选择问题分类");
                    return false;
                } else {
                    params.typeArr = JSON.stringify(that.type_id);
                }
                params.rewardType = that.type;
                params.title = that.title;
                if(params.title == ""){
                    this.utils.err("标题不能为空");
                    return false;
                }
                params.content = that.content;
                if(params.content == ""){
                    this.utils.err("内容不能为空");
                    return false;
                }
                params.images = that.imgs;
                params.videos = that.videos;
                params.files = that.files;

                params.images = JSON.stringify(that.imgs);
                params.videos = JSON.stringify(that.videos);
                params.files = JSON.stringify(that.files);
                params.roomId = that.roomId;
                var pennyList = [];
                for (let i = 0; i < that.distribution.length; i++) {
                    var List = {};
                    List.type = i+1;
                    if(that.distribution[i].people.length == ""){
                        this.utils.err("人数不能为空");
                        return false
                    }else {
                        List.people = that.distribution[i].people;
                    }
                    List.money = that.utils.keepTwoDecimalFull(that.distribution[i].inputMoney);
                    List.countMoney = that.utils.keepTwoDecimalFull(List.money * List.people);
                    List.userList = [];
                    pennyList.push(List);
                }
                params.pennyList = JSON.stringify(pennyList)
                if(that.need_money){
                    if (that.personamount == 0) {
                        that.utils.err('总金额不能为0')
                        return
                    }
                    // 总金额
                    params.rewardMoney = that.utils.keepTwoDecimalFull(that.personamount);
                    // 总人数
                    params.rewardPeopleSum = that.sumPeople;
                    // 天数
                    params.rewardDaySum = that.day;
                    //订单号
                    params.orderNo = that.orderNo;
                }else{
                    params.rewardMoney = 0;
                    params.rewardPeopleSum = 0;
                    params.rewardDaySum = 0;
                }
                that.redEnvelopesQuestion(params,type)
            },

            // 这是发布红包接口
            redEnvelopesQuestion(params,type){
                var that = this;
                console.log(that.need_money);
                that.newApi.redEnvelopesQuestion(params).then((ret)=>{
                    that.orderNo = ret.data.orderNo;
                    if(ret.isSuccess == 1){
                        if(type == 1){
                            that.utils.sus("添加成功");
                            that.$emit('close',{isReward:params.isReward});
                        }else if(type == 2) {
                            //v-if="payShow == true && (type == 1 || type == 4)"
                            // <aa-da-pay-code type = "3" :payType = "type" :payAmt="rewardMoney" :orderNo="orderNo" @change="changeOrder($event)" ref="child"> </aa-da-pay-code>
                            if(that.type == 1 || that.type == 4){
                                let payParams = that.$store.state.payParams;
                                payParams.type = 3;
                                payParams.payAmt = params.rewardMoney;
                                payParams.originalAmount = params.rewardMoney;
                                if(params.rewardType == 1){
                                    payParams.payType = 9;
                                }else{
                                    payParams.payType = 12;
                                }
                                payParams.orderNo = that.orderNo;
                                that.newApi.addAndSavePrePayOrder({type:1,payParams:JSON.stringify(payParams)}).then((res) => {
                                    if(res.isSuccess == 1){
                                        that.b('/adaPay/?sign=' + res.data.sign);
                                    }
                                })
                            }
                        }
                    }
                })
            },

            //  发布悬赏资料问答
            releasecode: function (type) {
                var that = this;
                var params = {};
                if(that.need_money){
                    that.isReward = 1;
                }
                params.isReward = that.isReward;
                if(that.type_id.length == 0){
                    that.utils.err("请选择问题内容");
                    return false;
                } else {
                    params.typeArr = JSON.stringify(that.type_id);
                }
                params.rewardType = that.type;
                params.title = that.title;
                if(params.title == ""){
                    this.utils.err("标题不能为空");
                    return false;
                }
                params.content = that.content;
                if(params.content == ""){
                    this.utils.err("内容不能为空");
                    return false;
                }
                params.images = that.imgs;
                params.videos = that.videos;
                params.files = that.files;

                params.images = JSON.stringify(that.imgs);
                params.videos = JSON.stringify(that.videos);
                params.files = JSON.stringify(that.files);
                params.roomId = that.roomId;
                if(that.need_money){
                    // 总金额
                    params.rewardMoney = that.utils.keepTwoDecimalFull(that.rewardMoney);
                    // 总人数
                    params.rewardPeopleSum = that.value;
                    // 天数
                    params.rewardDaySum = that.day;
                }else{
                    params.rewardMoney = 0;
                    params.rewardPeopleSum = 0;
                    params.rewardDaySum = 0;
                }
                that.introductionAdd(params,type)
            },

            // 发布悬赏资料问答悬赏讨论
            introductionAdd(params,type){
                var that = this;
                that.newApi.introductionAdd(params).then((ret)=>{
                    that.orderNo = ret.data.orderNo;
                    if(ret.isSuccess == 1){
                        if(type == 1){
                            that.utils.sus("添加成功");
                            that.$emit('close',{isReward:params.isReward});
                        }else if(type == 2) {
                            //<aa-da-pay-code type = "2" :payType = "type" :payAmt="rewardMoney" :orderNo="orderNo" @change="changeOrder($event)" ref="child"> </aa-da-pay-code>
                            if (that.type == 2 || that.type == 3) {
                                let payParams = that.$store.state.payParams;
                                payParams.type = 3;
                                payParams.payAmt = params.rewardMoney;
                                payParams.originalAmount = params.rewardMoney;
                                if(params.rewardType == 1){
                                    payParams.payType = 10;
                                }else{
                                    payParams.payType = 11;
                                }
                                payParams.orderNo = that.orderNo;
                                that.newApi.addAndSavePrePayOrder({type: 1,payParams: JSON.stringify(payParams)}).then((res) => {
                                    if(res.isSuccess == 1){
                                        that.b('/adaPay/?sign=' + res.data.sign);
                                    }
                                })
                            }
                        }
                    }
                })
            },

            //发布1-4内容匹配规则
            content_input(e){
                var string = e;
                string = string.replace(/<p>/g, "").replace(/<\/p>/g, "");
                string = string.charAt(string.length - 1);
                if (string == "@") {
                    this.at_open = true;
                }
            },

            set_upload_img_open() {
                if(this.videos.length > 0 || this.files.length > 0){
                    this.utils.err("图片、视频、文件只能上传一种");
                    this.visibleVideos = false;
                    return false;
                } else {
                    this.visibleImages = true;
                }
                this.visibleImages = true;
            },

            // 上传图片
            upload_img(params) {
                this.img_length++ ;
                if (this.img_length>80) {
                    this.$message.error('图片数量达到最大数量！');
                    return false;
                }
                var that = this;
                var file = params.file;
                if (file.type.indexOf('image') > -1) {
                    that.utils.upload(file,function(url){
                        if (!url){
                            return false;
                        }
                        let params = {};
                        params.name = url.name;
                        params.url = url.url;
                        params.hash = url.hash;
                        that.imgs.push(params);
                    })
                }else{
                    this.$message.error('只能上传图片！')
                    return false
                }
            },

            fileListNum:function (files) {
                if (files.length>this.limit) {
                    this.$message.error('图片数量不能超过80张!');
                }
            },

            // 取消图片上传
            cancelImg() {
                this.imgs = [];
                // this.$refs.popover.doClose();
                this.visibleImages = false;
            },

            // 取消视频上传
            cancelVideo() {
                this.videos = [];
                // this.$refs.popover2.doClose();
                this.visibleVideos = false;
            },

            // 取消文件上传
            cancelFiles() {
                this.files = [];
                this.visibleFiles = false;
            },

            //popover弹窗确定
            subPopover(value){
                if(value == 1) this.$refs.popover.doClose();
                else if(value == 2) this.$refs.popover2.doClose();
            },

            // 移除图片
            removeImg(index) {
                var that = this;
                that.imgs.splice(index, 1);
            },

            // 店家展示上传视频窗口
            set_visibleVideos() {
                if(this.imgs.length > 0 || this.files.length > 0){
                    this.utils.err("图片、视频、文件只能上传一种");
                    this.visibleVideos = false;
                    return false;
                }
                this.visibleVideos = true;
                this.common_type = '1'
            },

            // 上传视频
            upload_video(params) {
                var file = params.file;
                var that = this;
                let pa = {};

                if (file.type.indexOf('video') > -1) {
                    that.utils.upload(file,function(url) {
                        if (!url){
                            return false;
                        }
                        pa.name = url.name;
                        pa.url = url.url;
                        pa.hash = url.hash;
                        that.videos.push(pa);
                    })
                }else{
                    this.$message.error('只能上传视频！')
                    return false
                }
            },

            // 移除视频
            removeVideo(index){
                var that = this;
                that.videos.splice(index,1);
            },

            // 点击上传附件
            set_visibleFiles() {
                if(this.imgs.length > 0 || this.videos.length > 0){
                    this.utils.err("图片、视频、文件只能上传一种");
                    return false;
                }
                this.visibleFiles = true;
                this.common_type = '1'
            },

            //附件上传
            upload_file:function(params){
                var that = this;
                var file = params.file;
                that.utils.upload(file,function(url){
                    if (!url){
                        return false;
                    }
                    var obj = {
                        name:url.name,
                        url:url.url,
                        hash:url.hash
                    };
                    that.files.push(obj);
                })
            },
            // 移除附件
            removeFile(index) {
                var that = this;
                that.files.splice(index,1);
            },

            get_type_list(){
                var that = this;
                that.newApi.getTypeList({
                    lv: 3,
                }).then((res)=>{
                    that.type_list = res.data;
                }).catch((err)=>{
                    console.log(err)
                })
            },
            UpNumber(e) {
                e.target.value = e.target.value.replace(/[^\d]/g,"");
            },

            // 删除奖项事件
            deleteModule(index){
                var that = this;
                that.sumPeople = 0;
                that.personamount = 0;
                if(that.distribution.length < 1){
                    that.utils.err("必须保留一位奖项");
                    return false
                }else {
                    that.distribution.splice(index, 1);
                    for (let j = 0; j < that.distribution.length; j++) {
                        that.sumPeople += that.distribution[j].people;
                        that.distribution[j].money = that.distribution[j].people * parseFloat(that.distribution[j].inputMoney);
                        that.personamount += that.distribution[j].money;
                    }
                    that.hide = true;
                }
            },
            // 金额失去焦点
            lose(item){
                if (item.inputMoney ==''){
                    item.inputMoney = 0;
                    this.inputMoney()
                }
            }

        }
    }
</script>

<style scoped>
    .at_user{
        float: left;
        margin: 2.5px 5px;
        width: 90px;
        height: 40px;
        overflow: hidden;
        padding: 0px 5px;
    }
    .at_user.active{
        float: left;
        margin: 2.5px 5px;
        width: 90px;
        height: 40px;
        background: #C7E0F4;
        overflow: hidden;
        padding: 0px 5px;
    }
    .input_box_btn_name{
        float:left;
        margin-top: 5px;
        cursor:pointer;
        font-weight:bold;
    }
    .input_box_btn_icon{
        float:left;
        font-size:20px;
        line-height:28px;
        margin-right:5px;
    }
    .el-date-editor.el-input {
        width: 200px;
    }
    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    .peoold {
        width: auto;
        height: 21px;
        font-size: 16px;
        color: #909399;
        float: left;
        font-weight:bold
    }
    .number {
        width: auto;
        height: 21px;
        font-size: 16px;
        color: #909399;
        float: left;
        font-weight:bold
    }
    /deep/ .el-dialog__body {
        padding: 0px 0px;
    }

    /deep/ .el-card{
        border: 0px solid #EBEEF5;
    }
    /deep/ .v-modal {
        background: #FFFFFF;
    }
    /deep/ .el-form-item__content{
        line-height: 0px;
    }
    /deep/ .el-textarea .el-input__count {
        bottom: 10px;
    }
    /deep/.el-form-item {
        margin-bottom: 10px;
    }

    /deep/ .el-button {
        color: #FFF;
        background-color: #409EFF;
        border: 1px solid #409EFF;
    }
    .input_box_btn {
        margin-right: 30px;
        float: left;
    }
    /deep/ .center-label {
        text-align: center;
    }
    .offerareward {
        width: auto;
        height: 21px;
        font-size: 16px;
        color: #909399;
        float: left;font-weight:bold;
        flex-basis: 10%;
    }
    /deep/ .el-form-item__label {
        font-size: 15px;
    }
    /deep/ .el-button--small {
        padding: 7px 15px;
    }
</style>
